<template>
  <div>
    <v-select
      :outlined="outlined"
      :solo="solo"
      :color="color"
      v-model="localeSelect"
      v-if="compact != null"
      item-text="text"
      item-value="value"
      :items="$locales"
      @input="inputSelect"
      style="width: 90px"
    >
      <template slot="selection" slot-scope="{ item }">
        <span :class="item.class + ' ml-3 text-center'"></span>
      </template>

      <template slot="item" slot-scope="{ item }">
        <span :class="item.class + ' text-center'"></span>
      </template>
    </v-select>

    <v-select
      :outlined="outlined"
      :solo="solo"
      :color="color"
      v-else
      v-model="localeSelect"
      item-text="text"
      item-value="value"
      :items="$locales"
      @input="inputSelect"
    >
      <template slot="selection" slot-scope="{ item }">
        <span :class="item.class + ' mr-3 ml-5'"></span>
        {{ compact != null ? "" : item.text }}
      </template>

      <template slot="item" slot-scope="{ item }">
        <span :class="item.class + ' mr-3'"></span>
        {{ compact != null ? "" : item.text }}
      </template>
    </v-select>
  </div>
</template>


<script>
export default {
  props: ["compact", "color", "outlined", "solo", "localeDefault"],
  data() {
    return { localeSelect: "" };
  },
  methods: {
    inputSelect(item) {
      if (!item) return;
      if (this.$i18n.locale == item) return;
      this.$i18n.locale = item;
      this.$setItem("simjob_locale", item);
      this.$forceUpdate();
    },
  },
  async mounted() {
    if (this.localeDefault != undefined) {
      const localeDefault = process.env.VUE_APP_LOCALE_DEFAULT;
      if (localeDefault) this.$i18n.locale = localeDefault;
      this.localeSelect = localeDefault || this.$i18n.locale;
      return;
    }
    let locale = await this.$getItem("simjob_locale");
    if (locale == null) this.localeSelect = this.$i18n.locale;
    else this.localeSelect = locale;
  },
};
</script>